import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import DoubleButton from 'components/popup/components/DoubleButton';
import TextInput from 'components/TextInput';
import * as Yup from 'yup';
import validationShema from 'constants/ValidationShema';
import useId from 'hooks/useId';
import {connect} from 'react-redux'

function UserRegistrationRejectPopup(
    {
        onClose,
        onReject,
        formSubmit
    }) {

    const formId = useId();
    const handleSubmit = () => formSubmit[formId]()

    return (
        <Dialog
            title={Tr('reject')}
            open
            maxWidth={'md'}
            dialogActions={
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('reject')}
                    onClickFirst={onClose}
                    onClickSecond={handleSubmit}
                />}
        >
            <Form
                initialValues={{
                    rejectionReason: ""
                }}
                validationSchema={Yup.object().shape({
                    rejectionReason: validationShema.stringMaxNoRq(500),
                })}
                onSubmit={onReject}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        <TextInput
                            id='rejectionReason'
                            formikProps={formikProps}
                            label={Tr('registration_form_reject_reason')}
                            limit={500}
                            multiline
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(UserRegistrationRejectPopup);